import { serviceProxy } from "./apiProxyService";
//TODO: Esta función no va a manejarse, debido que ya sabemos como consultar información desde backstage
export const getUsersList = async (config: any) => {
    const result = await serviceProxy(
        config,
        "get-data-yaml",
        "GET",
        {},
        { pathFile: 'org/da-users.yaml' }
    );
    if (result.code === 201) {
        // const newList = result.data.map((item: any) => {
        //     return {
        //         name: item.metadata.name,
        //         displayName: item.spec.profile.displayName,
        //         picture: item.spec.profile.picture,
        //         email: item.spec.profile.email,
        //         memberOf: item.spec.memberOf
        //     }
        // });
        return result.data;
    }
    return [];
};

export const putDataYaml = async (body: { config: any, pathFile: string, content: any }) => {
    const { config, pathFile, content } = body;
    const result = await serviceProxy(
        config,
        "/save-data-yaml",
        "POST",
        content,
        { pathFile: `org/${pathFile}` }
    );
    if (result.code === 201) {
        return [{ code: result.code, action: 'sended' }];
    }
    return [{ code: result.code, action: 'failed' }];
};
